import { IsUUID, IsNotEmpty } from 'class-validator';

import { FilterType } from '@vk-hr-tek/core/filter';

export class GetVacaitionsCompaniesListDto {
  @IsUUID()
  @IsNotEmpty()
  company_id: string;

  filters?: FilterType;
}
